export const AnimationPhase = {
    EnterActive: 'enter-active',
    EnterDone: 'enter-done',
    ExitActive: 'exit-active',
    ExitDone: 'exit-done',
};
export const createAnimationState = (phase, getAnimationDuration) => ({
    phase,
    isVisible: getIsVisible(phase),
    duration: getAnimationDuration?.(),
});
export const getIsVisible = (animationPhase) => {
    return animationPhase !== AnimationPhase.ExitDone;
};
//# sourceMappingURL=animationState.js.map